import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const orderRoutes: RouteRecordRaw[] = [
    {
        name: 'order-navigation',
        path: '/order/navigation',
        component: () => import('@/views/order/OrderNavigation.vue'),
        beforeEnter: () => haveOneAccess([permissionList.READ_ORDER, permissionList.CREATE_ORDER, permissionList.REFUND_ORDER]) ? true : { name: 'dashboard' },
    },
    {
        name: 'order',
        path: '/order',
        component: () => import('@/views/order/OrderIndex.vue'),
        beforeEnter: () => canAccess(permissionList.READ_ORDER) ? true : { name: 'order-navigation' },
    },
    {
        name: 'order-detail',
        path: '/order/:id(\\d+)',
        component: () => import('@/views/order/DetailOrder.vue'),
        beforeEnter: () => haveOneAccess([permissionList.READ_ORDER, permissionList.CREATE_ORDER, permissionList.REFUND_ORDER]),
    },
    {
        name: 'order-new',
        path: '/order/new',
        component: () => import('@/views/order/NewOrder.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_ORDER) ? true : { name: 'order-navigation' },
    },
    {
        name: 'order-update',
        path: '/order/update/:id(\\d+)',
        component: () => import('@/views/order/UpdateOrder.vue'),
        beforeEnter: () => canAccess(permissionList.UPDATE_ORDER) ? true : { name: 'order-navigation' },
    },
    {
        name: 'order-refund',
        path: '/order/refund/:id(\\d+)?',
        component: () => import('@/views/order/RefundOrder.vue'),
        beforeEnter: () => canAccess(permissionList.REFUND_ORDER) ? true : { name: 'order-navigation' },
    },
]

export default orderRoutes
